import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import LoadingOverlay from 'components/LoadingOverlay';
import ParallaxContext, { useParallaxContextValue } from './context';

const ParallaxWrapperFiber = lazy(() =>
  import('components/ParallaxWrapperFiber').catch(() => window.location.reload())
);

const ParallaxProvider = ({ children }) => {
  const value = useParallaxContextValue();

  if (value.isEnabled) {
    return (
      <ParallaxContext.Provider value={value}>
        <Suspense fallback={<LoadingOverlay isLoading />}>
          <ParallaxWrapperFiber bg="minsk">{children}</ParallaxWrapperFiber>
        </Suspense>
      </ParallaxContext.Provider>
    );
  }
  return <ParallaxContext.Provider value={value}>{children}</ParallaxContext.Provider>;
};

ParallaxProvider.propTypes = {
  children: PropTypes.node
};

export default ParallaxProvider;
